import { InverseHeader } from '@jouzen/ecom-components';

import ScienceAndResearchHeroOR4 from './ScienceAndResearchHeroOR4';

const ScienceAndResearchHero = (): JSX.Element => {
  return (
    <div data-cy="science-and-research-hero">
      <InverseHeader enter>
        <ScienceAndResearchHeroOR4 />
      </InverseHeader>
    </div>
  );
};

export default ScienceAndResearchHero;
